<div class="row animated fadeInRight" *ngIf="!mostrarFormulario">

    <!-- *FORMULARIO GUARDAR ROL  -->
    <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
        [innTemplate]="enviarTemplateEdit" [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo"
        [tituloCard]="titulo">
    </app-lfsa-card-v2>
    <ng-template #innTemplateButton>
    </ng-template>
    <ng-template #enviarTemplateEdit>
        <form [formGroup]="formulario" novalidate class="form-group">
            <div class="row">
                <div class="form-group col-md-6">
                    <app-lfsa-input [placeholder]="'Descripcion'" [label]="'Descripcion'" [id]="'descripcion'"
                        formControlName="descripcion" [control]="formulario.get('descripcion')">
                    </app-lfsa-input>
                </div>
            </div>
            <app-lfsa-botones-formulario [loading]="loading" [formularioValido]="formulario.invalid"
                (devolverAccion)="acciones ( $event )" [textBoton]="textBoton">
            </app-lfsa-botones-formulario>
        </form>
    </ng-template>

    <!-- *GRID LISTAR ROL -->
    <app-lfsa-card-v2 *ngIf="mostrarGridLista" [innTemplateButton]="innTemplateButtonAddRol"
        [innTemplate]="enviarTemplate" [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo"
        [tituloCard]="titulo">
    </app-lfsa-card-v2>
    <ng-template #innTemplateButtonAddRol>
        <div class="col-md-6">
            <div class="pagetitle">
                <div class="btn-group-justified btn-group" style="float: right;">
                    <a class="btn btn-outline-success" (click)="nuevo()">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                        {{DAT_BTNS.agregarRol}}
                    </a>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #enviarTemplate>
        <section class="section">
            <div class="row">
                <div class="col-md-12 ">
                    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
                    <ag-grid-angular class="{{diccionarioModulo.agGrid.class}}" #agGrid [floatingFilter]="true"
                        [ngStyle]="diccionarioModulo.agGrid.style" id="{{diccionarioModulo.agGrid.id}}"
                        [paginationPageSize]="$any(diccionarioModulo.agGrid).paginacion" [pagination]="true"
                        [frameworkComponents]="frameworkComponents" [columnDefs]="columnDefs"
                        [rowSelection]="rowSelection" [rowData]="rowData" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </section>
    </ng-template>
</div>


<div class="row animated fadeInRight" *ngIf="mostrarFormulario">

    <!-- *FORMULARIO AGREGAR SESSIONES POR ROL -->
    <app-lfsa-card-v2 [innTemplate]="enviarTemplateAddSesion" [innTemplateButton]="innTemplateButtonAddSesion"
        [titulo]="DAT_TITULOS.titulo" [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardAgregarSesion">
    </app-lfsa-card-v2>
    <ng-template #innTemplateButtonAddSesion>
    </ng-template>
    <ng-template #enviarTemplateAddSesion>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <div class="card border-success">
                    <div class="card-body">
                        <ag-grid-angular #agGrid style="width: 100%; height: 350px; " class="ag-theme-alpine mt-3"
                            [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefsRol"
                            [rowSelection]="rowSelection" [rowData]="rowDataRol" [floatingFilter]="true">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                <div class="card border-success">
                    <div class="card-body">
                        <br>
                        <form [formGroup]="formularioAgregarRol" novalidate class="form-group">
                            <div class="row">
                                <div class="form-group col-12 col-md-12">
                                    <app-lfsa-combo-box [opcion]="'codSesion'" [idOpcion]="'id'" [label]="'Sesiones*'"
                                        [comboBox]="cmbListaSession" formControlName="sesionId"
                                        [control]="formularioAgregarRol.get('sesionId')" [id]="'idRol'">
                                    </app-lfsa-combo-box>
                                </div>
                                <div class="form-group col-12 col-md-6" hidden="false">
                                    <app-lfsa-input [placeholder]="'Id'" [label]="'Id'" [id]="'id'"
                                        formControlName="rolId" [control]="formularioAgregarRol.get('rolId')">
                                    </app-lfsa-input>
                                </div>
                            </div>
                            <app-lfsa-botones-formulario [loading]="loading"
                                [formularioValido]="formularioAgregarRol.invalid"
                                (devolverAccion)="accionesAgregarRoles( $event )" [textBoton]="DAT_BTNS.agregarRol">
                            </app-lfsa-botones-formulario>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>


